import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Input,
  InputGroup,
  CardTitle,
  TextArea,
} from "reactstrap"
import axios from "axios";
import {API_URL} from "../../../constants/constants";
import {showMessage} from "../../../components/Common/Toaster";
import {
  showErrorMessages,
} from "helpers/helpers"
function PersonalDetails(props) {
  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [email, set_email] = useState("");

  useEffect(() => {
    set_first_name(props?.userData.first_name || "")
    set_last_name(props?.userData.last_name || "")
    set_email(props?.userData.email || "")
  }, [props?.userData])

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      first_name: first_name,
      last_name: last_name,
      email: email,
    };
    axios({
      method: "post",
      url: `${API_URL}/admin/users/${props?.userData.id}/update-profile`,
        data
    })
        .then(function (response) {
          showMessage("success", response.data.message)
        })
        .catch(function (response) {

          showErrorMessages(response)
        })

  };
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Personal Details</CardTitle>

        <Form onSubmit={handleSubmit}>
          <div className="row mb-4">
            <Col xs={4} sm={2} md={2} lg={4}>
              <Label className="col-form-label">First Name</Label>
            </Col>
            <Col xs={8} sm={10} md={10} lg={8}>
              <input className="form-control" type="text"
                     onChange={(e) => {
                       set_first_name(e.target.value);
                     }}
                     value={first_name}/>
            </Col>
          </div>
          <div className="row mb-4">
            <Col xs={4} sm={2} md={2} lg={4}>
              <Label className="col-form-label">Last Name</Label>
            </Col>
            <Col xs={8} sm={10} md={10} lg={8}>
              <input className="form-control" type="text"
                     onChange={(e) => {
                       set_last_name(e.target.value);
                     }}
                     value={last_name}/>
            </Col>
          </div>
          <div className="row mb-4">
            <Col xs={4} sm={2} md={2} lg={4}>
              <Label className="col-form-label">Email</Label>
            </Col>
            <Col xs={8} sm={10} md={10} lg={8}>
              <input className="form-control" type="text"
                     onChange={(e) => {
                       set_email(e.target.value);
                     }}
                     value={email}/>
            </Col>
          </div>
          {/*<div className="row mb-4">*/}
          {/*  <Col xs={4} sm={2} md={2} lg={4}>*/}
          {/*    <Label className="col-form-label">Address</Label>*/}
          {/*  </Col>*/}
          {/*  <Col xs={8} sm={10} md={10} lg={8}>*/}
          {/*    <Input type="textarea" id="textarea" maxLength="225" rows="3" />*/}
          {/*  </Col>*/}
          {/*</div>*/}
          {/*<div className="row mb-4">*/}
          {/*  <Col xs={4} sm={2} md={2} lg={4}>*/}
          {/*    <Label className="col-form-label">Gender</Label>*/}
          {/*  </Col>*/}
          {/*  <Col xs={8} sm={10} md={10} lg={8}>*/}
          {/*    <select className="form-control">*/}
          {/*      <option>Male</option>*/}
          {/*      <option>Female</option>*/}
          {/*      <option>Other</option>*/}
          {/*    </select>*/}
          {/*  </Col>*/}
          {/*</div>*/}
          <div className="row mb-4">
            <Col lg={4}></Col>
            <Col lg={8}>
              <button
                className="w-md btn btn-primary"
                type="submit"
                id="disableLoginButtonClick"

              >
                Update
              </button>
            </Col>
          </div>
        </Form>
      </CardBody>
    </Card>
  )
}

export default PersonalDetails
